import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  AlertTitle,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  IconButton,
  Pagination,
  CircularProgress,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import ResumeContext from "./Resumecontext";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { AiOutlineCloseCircle } from "react-icons/ai";
import parse from "html-react-parser";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { BsArrowLeftCircle } from "react-icons/bs";
import { openAI } from "../../Components/common/OpenAIComponent";
import { myCandidatesSelector } from "../MyCandidates/redux/selector";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import { appSelector } from "../redux/selector";
import {
  IsOpenSummary,
  ResumeProjectsData,
  updateProjectsAction,
} from "./ResumeBuilderActions/actions";
import { resumeBuilderSelector } from "./ResumeBuilderActions/selector";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckIcon from "@mui/icons-material/Check";
import HourTimer from "../images/sandtimer.gif";
import { toast } from "react-toastify";

export default function Projects({ setValue, setResponsibilities }) {
  const theme = useTheme();
  const formikRef = useRef();
  const dispatch = useDispatch();
  const contextObject = useContext(ResumeContext);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [suggestionsLoading, setSuggestionsLoading] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [copiedIndex, setCopiedIndex] = useState([]);
  const [projectSuggestions, setProjectSuggestions] = useState([]);
  const [finish, setFinish] = useState(false);
  const [update, setUpdate] = useState(false);
  const [buttonLoadingOne, setButtonLoadingOne] = useState(false);
  const ITEMS_PER_PAGE = 10;
  const { selectedJob } = useSelector(appSelector);
  const { resumeProjectsData, resumeFullDetails, currentSection, projects } =
    useSelector(resumeBuilderSelector);
  // console.log("resumeProjectsData: " + resumeProjectsData);

  const handlefinish = () => {
    setFinish(true);
  };

  const handleInputChange = (e, value, fieldname) => {
    //console.log(e);
    //console.log("projecte", value);
    let Certifications = [...contextObject.project];
    //console.log(Certifications);
    var name = fieldname !== undefined ? fieldname : e.target?.name;
    //console.log(name);

    if (name === "client") {
      Certifications[0].company = e.target?.value;
      contextObject.updateProject(Certifications);
      formikRef.current.setFieldValue("client", e.target.value);
    }
    if (name === "Role") {
      Certifications[0].role = e.target?.value;
      formikRef.current.setFieldValue("Role", e.target.value);
    }
    if (name === "projectTitle") {
      Certifications[0].projectTitle = e.target?.value;
      formikRef.current.setFieldValue("projectTitle", e.target.value);
      //console.log(contextObject.project);
    }
    contextObject.updateProject(Certifications);
    //console.log(Certifications);
  };

  const onTextEditorchanged = (value) => {
    let Certifications = [...contextObject.project];
    // const resslice = value?.slice(0,500)
    Certifications[0].responsibilities = value;
    formikRef.current.setFieldValue("projectResponsibilitites", value);
    contextObject.updateProject(Certifications);
    //setCharCount(value?.length);
  };
  const handleChangePage = (event, value) => setCurrentPage(value);
  const paginatedData = projectSuggestions?.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const selectedProject = resumeFullDetails.projectdetails?.find(
    (project) => project.id == currentSection?.id
  );

  const getProjectSuggestions = () => {
    //console.log(formikRef?.current?.values?.Role);
    //setProjectIndex(index)
    if (
      selectedProject !== undefined &&
        selectedProject?.pro_role &&
        selectedProject.pro_role !== "null" &&
        selectedProject.pro_role !== "undefined"
        ? selectedProject.pro_role
        : formikRef?.current?.values?.Role
    ) {
      setCopiedIndex([]);
      setOpen(true);
      setSuggestionsLoading(true);
      // const msg = `The following is the role of a project. Based on this project role, please provide suggestions for the roles and responsibilities. Ensure that the output is in JSON format, with each suggestion listed as a separate item. The project role is for a ${selectedProject?.pro_role}.

      // Format the output as:
      // {
      //   "suggestions": [
      //     "Suggestion 1",
      //     "Suggestion 2",
      //     "Suggestion 3",
      //     ...
      //   ]
      // }
      // Only include relevant information that is specific to the job role and experience. Focus on actionable, role-specific responsibilities and tasks.`;

      const projectRole = formikRef?.current?.values?.Role || selectedProject?.pro_role;
      const projectTitle = formikRef?.current?.values?.projectTitle || selectedProject?.pro_title;
      const projectClient = formikRef?.current?.values?.client || selectedProject?.pro_client;

      const msg = `The following is the job description and project information. Based on both the job description and the specific project details, please provide suggestions for the roles and responsibilities. Ensure that the output is in JSON format, with each suggestion listed as a separate item. Ensure that the summary includes at least 30 points, with each point relevant and informative. 
          
          Job Description: ${selectedJob?.job_description || 'Not provided'}
          Project Role: ${projectRole || 'Not specified'}
          Project Title: ${projectTitle || 'Not specified'}
          Project Client/Company: ${projectClient || 'Not specified'}

          Format the output as:
          {
            "suggestions": [
              "Suggestion 1",
              "Suggestion 2",
              "Suggestion 3",
              ...
            ]
          }
          Ensure that each suggestion contains at least 20 words. Only include relevant information that is specific to the job role and experience. Focus on actionable, role-specific responsibilities and tasks that connect the project details with the job description.`;

      openAI(msg, (error, results) => {
        if (error) {
          setSuggestionsLoading(false);
        } else {
          var data = results;
          //console.log("data", data);
          let combinedData = [];

          setProjectSuggestions(data?.suggestions);
          setSuggestionsLoading(false);
        }
      });
    } else {
      let msg = "Please Enter Project Role";
      // toast(<ToastMessage message={msg} />);
    }
  };
  const handleMouseEnter = (index) => {
    //console.log("index", index);
    setHoveredIndex(index);
    if (isCopied(index)) {
      setHoveredIndex(index);
    }
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };
  const handleRolesClose = () => {
    setOpen(false);
  };

  // const handleSuggestionsClick = (index, data) => {
  //   console.log("indexc", index);
  //   handleSummaryClick(data);
  //   if (!copiedIndex.includes(index)) {
  //     navigator.clipboard.writeText(data);
  //     setCopiedIndex([...copiedIndex, index]);
  //     console.log("indexco", [...copiedIndex, index]);
  //   }
  // };

  const handleSuggestionsClick = (index, data) => {
    setCopiedIndex((prevState) => {
      const pageIndexes = prevState[currentPage] || [];
      if (pageIndexes.includes(index)) {
        handleRemoveFromSummary(data);
        return {
          ...prevState,
          [currentPage]: pageIndexes.filter((i) => i !== index),
        };
      } else {
        handleSummaryClick(data);
        return { ...prevState, [currentPage]: [...pageIndexes, index] };
      }
    });
  };

  const isCopied = (index) => copiedIndex[currentPage]?.includes(index);
  const handleSummaryClick = (summary) => {
    // Update context
    const projects = [...contextObject.project];
    if (projects.length > 0) {
      const currentResponsibilities = projects[0].responsibilities || "";
      projects[0].responsibilities = currentResponsibilities + summary;
      contextObject.updateProject(projects);
    }

    // Update formik
    const responsibilitiesValue = formikRef?.current?.values?.projectResponsibilitites || "";
    formikRef.current.setFieldValue(
      "projectResponsibilitites",
      responsibilitiesValue + summary
    );

    // Update Redux state
    const updatedProjects = resumeProjectsData.map(project =>
      project.id === currentSection?.id
        ? {
          ...project,
          pro_responsibilities: (project.pro_responsibilities || "") + summary
        }
        : project
    );
    dispatch(ResumeProjectsData(updatedProjects));
    dispatch(updateProjectsAction(updatedProjects));

    setResponsibilities((prevContent) => [...prevContent, summary]);
  };

  const handleRemoveFromSummary = (summary) => {
    // Update context
    const projects = [...contextObject.project];
    if (projects.length > 0) {
      projects[0].responsibilities = (projects[0].responsibilities || "").replace(summary, "");
      contextObject.updateProject(projects);
    }

    // Update formik
    const responsibilitiesValue = formikRef?.current?.values?.projectResponsibilitites || "";
    formikRef.current.setFieldValue(
      "projectResponsibilitites",
      responsibilitiesValue.replace(summary, "")
    );

    // Update Redux state
    const updatedProjects = resumeProjectsData.map(project =>
      project.id === currentSection?.id
        ? {
          ...project,
          pro_responsibilities: (project.pro_responsibilities || "").replace(summary, "")
        }
        : project
    );
    dispatch(ResumeProjectsData(updatedProjects));
    dispatch(updateProjectsAction(updatedProjects));

    setResponsibilities((prevContent) =>
      prevContent.filter((item) => item !== summary)
    );
  };

  const handleUpdateProject = async (projectdetails) => {
    const NewProjectDetails = {
      id: currentSection?.id,
      pro_client: projectdetails.client,
      pro_role: projectdetails.Role,
      pro_country: projectdetails.country,
      pro_state: projectdetails.pro_state,
      pro_city: projectdetails.pro_city,
      pro_startdate: selectedProject.pro_startdate,
      pro_enddate: selectedProject.pro_enddate,
      pro_title: projectdetails.projectTitle,
      pro_responsibilities: projectdetails.projectResponsibilitites,
      pro_description: selectedProject.pro_description,
      is_current_project: selectedProject.is_current_project,
      pro_client_domain: selectedProject.pro_client_domain,
      pro_technologies: selectedProject.pro_technologies,
      pro_address_full: selectedProject.pro_address_full,
      pro_zipcode: selectedProject.pro_zipcode,
      pro_till_date: selectedProject.pro_till_date,
      pro_createdate: selectedProject.pro_createdate,
      pro_modified: selectedProject.pro_modified,
      pro_createdtime: selectedProject.pro_createdtime,
      pro_country_new: selectedProject.pro_country_new,
      pro_state_new: selectedProject.pro_state_new,
      pro_city_new: selectedProject.pro_city_new,
      cityname: selectedProject.cityname,
      countryName: selectedProject.countryName,
    };

    //console.log("handleUpdateProject", NewProjectDetails);

    const updatedProjectsAPI = resumeProjectsData.map((project) =>
      project.id === currentSection?.id ? NewProjectDetails : project
    );
    const ResumeupdatedProjects =
      projects?.length > 0 &&
      projects.map((project) =>
        project.id === currentSection?.id ? NewProjectDetails : project
      );

    setUpdate(true);
    //setFinish(true)
    //console.log("Updated Projects Array:", updatedProjectsAPI);
    //console.log("Updated Projects Length:", updatedProjectsAPI?.length);
    await dispatch(ResumeProjectsData(updatedProjectsAPI));
    await dispatch(updateProjectsAction(ResumeupdatedProjects));
    toast.success("Projects updated successfully");
  };

  useEffect(() => {
    if (formikRef.current && currentSection?.id !== null) {
      // Initialize form values from selected project
      formikRef.current.setFieldValue("Role", selectedProject?.pro_role);
      formikRef.current.setFieldValue("projectTitle", selectedProject?.pro_title);
      formikRef.current.setFieldValue(
        "startDate",
        moment(selectedProject?.pro_startdate).format("YYYY-MM")
      );
      formikRef.current.setFieldValue(
        "endDate",
        selectedProject?.pro_enddate === "" ||
          selectedProject?.pro_enddate === "undefined"
          ? ""
          : moment(selectedProject?.pro_enddate).format("YYYY-MM")
      );
      formikRef.current.setFieldValue(
        "countryname",
        selectedProject?.countryName !== undefined
          ? selectedProject?.countryName
          : selectedProject?.pro_country || "US"
      );
      formikRef.current.setFieldValue(
        "statename",
        selectedProject?.statename === undefined ||
          selectedProject?.statename === null
          ? selectedProject?.pro_state
          : selectedProject?.statename
      );
      formikRef.current.setFieldValue(
        "cityname",
        selectedProject?.cityname !== undefined
          ? selectedProject?.cityname
          : selectedProject?.pro_city
      );
      formikRef.current.setFieldValue("client", selectedProject?.pro_client);
      formikRef.current.setFieldValue(
        "projectDescription",
        selectedProject?.pro_description
      );
      formikRef.current.setFieldValue(
        "projectResponsibilitites",
        selectedProject?.pro_responsibilities
      );
      formikRef.current.setFieldValue(
        "checked",
        selectedProject?.is_current_project === 1 ? true : false
      );

      // Update context with project data
      let Certifications = [...contextObject.project];
      if (Certifications.length === 0) {
        Certifications = [{
          projectTitle: selectedProject?.pro_title || "",
          country: selectedProject?.pro_country || "",
          countryname: selectedProject?.countryName || "",
          state: selectedProject?.pro_state || "",
          statename: selectedProject?.statename || "",
          city: selectedProject?.pro_city || "",
          cityname: selectedProject?.cityname || "",
          responsibilities: selectedProject?.pro_responsibilities || "",
          description: selectedProject?.pro_description || "",
          startdate: selectedProject?.pro_startdate || "",
          company: selectedProject?.pro_client || "",
          enddate: selectedProject?.pro_enddate || "",
          role: selectedProject?.pro_role || "",
          checked: selectedProject?.is_current_project === 1
        }];
      } else {
        Certifications[0] = {
          ...Certifications[0],
          projectTitle: selectedProject?.pro_title || "",
          country: selectedProject?.pro_country || "",
          countryname: selectedProject?.countryName || "",
          state: selectedProject?.pro_state || "",
          statename: selectedProject?.statename || "",
          city: selectedProject?.pro_city || "",
          cityname: selectedProject?.cityname || "",
          responsibilities: selectedProject?.pro_responsibilities || "",
          description: selectedProject?.pro_description || "",
          startdate: selectedProject?.pro_startdate || "",
          company: selectedProject?.pro_client || "",
          enddate: selectedProject?.pro_enddate || "",
          role: selectedProject?.pro_role || "",
          checked: selectedProject?.is_current_project === 1
        };
      }
      contextObject.updateProject(Certifications);
    }
  }, [selectedProject, currentSection?.id]);

  const HandleUpload = () => {
    contextObject.updateFinishOne(true);
    setButtonLoadingOne(true);
  };

  const paperstyles = {
    height: "75vh",
    overflow: "auto",
  };
  const [openJd, setOpenJd] = useState(false);

  const openDialog = () => {
    setOpenJd(true);
  };

  const closeDialog = () => {
    setOpenJd(false);
  };

  // Add this new useEffect to sync data when component mounts or currentSection changes
  useEffect(() => {
    if (currentSection?.id && resumeProjectsData?.length > 0) {
      const currentProject = resumeProjectsData.find(p => p.id === currentSection.id);
      if (currentProject) {
        // Update formik
        formikRef.current?.setFieldValue("projectResponsibilitites", currentProject.pro_responsibilities || "");

        // Update context
        const projects = [...contextObject.project];
        if (projects.length > 0) {
          projects[0].responsibilities = currentProject.pro_responsibilities || "";
          contextObject.updateProject(projects);
        }
      }
    }
  }, [currentSection?.id, resumeProjectsData]);

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          padding: 2,
          border: "1px solid #e6e1e1",
          borderRadius: "10px",
          borderTop: "3px solid #406682",
          boxShadow: "0 0 2px grey",
          ...paperstyles,
        }}
      >
        <Grid container>
          <Grid xs={7}>
            <Typography
              variant="h6"
              sx={{
                background: "linear-gradient(-90deg, #89bcdf 10%, #406882 90%)",
                backgroundClip: "text",
                textFillColor: "transparent",
                fontWeight: "bold",
              }}
            >
              Projects
            </Typography>
            <Typography sx={{ color: "grey", mb: 1 }}>
              Boost your resume by highlighting your outstanding projects!.
            </Typography>
          </Grid>
          <Grid
            item
            xs={5}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              textAlign: "right",
              alignItems: "center",
            }}
          >
            <Button
              onClick={openDialog}
              sx={{
                fontSize: "13px",
                //fontWeight: 600,
                padding: "0px 10px",
                height: "30px",
                borderRadius: "22px 22px 22px 22px",
                color: "#406682",
                textTransform: "none",
                backgroundColor: "white",
                cursor: "pointer",
                border: "1px solid #406682",
                transition: "all 0.3s ease-in-out",
                "&:hover": {
                  backgroundColor: "#406682",
                  color: "white",
                  border: "1px solid #406682",
                },
              }}
            >
              Job Description
            </Button>
          </Grid>
        </Grid>
        <Box sx={{ px: "10px", mb: 2 }}>
          <Formik
            innerRef={formikRef}
            initialValues={{
              projectTitle: "",
              country: selectedProject?.pro_country,
              countryname: "",
              state: selectedProject?.pro_state,
              statename: "",
              city: selectedProject?.pro_city,
              cityname: "",
              projectResponsibilitites: "",
              projectDescription: "",
              startDate: "",
              client: "",
              endDate: "",
              Role: "",
              checked: false,
            }}
            validationSchema={Yup.object({
              // projectTitle: Yup.string().required("Project Title is required"),
              Role: Yup.string().required("Role is required"),
              startDate: Yup.string().required("Start Date is required"),
              client: Yup.string().required("Company is required"),
              //endDate: Yup.string().required("End Date is required"),
            })}
            onSubmit={(values) => {
              //console.log("formik", values);
              handleUpdateProject(values);
            }}
          >
            {({ values, handleBlur, handleSubmit, errors, touched }) => (
              <form onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <label htmlFor={`projectTitle`}>Project Title </label>
                    <input
                      type="text"
                      id={`projectTitle`}
                      name={`projectTitle`}
                      onChange={(e) => {
                        handleInputChange(e);
                        //console.log(e);
                      }}
                      value={values.projectTitle}
                      className={`form-control `}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <label htmlFor={`Role`}>
                      Role <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      id="Role"
                      name="Role"
                      value={values.Role}
                      onChange={(e) => {
                        handleInputChange(e);
                      }}
                      // onBlur={() => getProjectSuggestions(index)}
                      onBlur={handleBlur}
                      className={`form-control ${touched.Role && errors.Role ? "is-invalid" : ""
                        }`}
                    />
                    <ErrorMessage
                      name={`Role`}
                      component="div"
                      className="invalid-feedback"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <label htmlFor={`client`}>
                      Client <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      id={`client`}
                      name={`client`}
                      value={values.client}
                      onChange={(e) => {
                        handleInputChange(e);
                      }}
                      onBlur={handleBlur}
                      className={`form-control ${touched.client && errors.client ? "is-invalid" : ""
                        }`}
                    //placeholder="Client"
                    />
                    <ErrorMessage
                      name="client"
                      component="div"
                      className="invalid-feedback"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <label>Roles & Responsibilities</label>
                      <Button
                        // variant="outlined"
                        size="small"
                        onClick={() => getProjectSuggestions()}
                        startIcon={<AddCircleRoundedIcon />}
                        style={{
                          cursor: "pointer",
                          textTransform: "none",
                          marginRight: "2px",
                          borderRadius: "50px",
                          width: "170px",
                          height: "28px",
                          backgroundColor: "#406882",
                          color: "white",
                        }}
                      >
                        SuggestedPhrases
                      </Button>
                    </Box>
                    <ReactQuill
                      theme="snow"
                      name="projectResponsibilitites"
                      value={values.projectResponsibilitites}
                      onChange={(e) => {
                        //console.log("quil data", e);

                        // 1. Update formik value
                        formikRef.current.setFieldValue("projectResponsibilitites", e);

                        // 2. Update context immediately
                        const projects = [...contextObject.project];
                        if (projects.length > 0) {
                          projects[0].responsibilities = e;
                          contextObject.updateProject(projects);
                        }

                        // 3. Update Redux state immediately
                        const updatedProjects = resumeProjectsData.map(project =>
                          project.id === currentSection?.id
                            ? { ...project, pro_responsibilities: e }
                            : project
                        );
                        dispatch(ResumeProjectsData(updatedProjects));
                        dispatch(updateProjectsAction(updatedProjects));

                        // 4. Update responsibilities state for highlighting
                        setResponsibilities(prev => [...prev, e]);

                        // 5. Keep the existing onTextEditorchanged call for backward compatibility
                        onTextEditorchanged(e);
                      }}
                    />
                    {/* <div>{charCount} / 500 characters</div>
                  {values?.projectResponsibilitites?.length > 500 ? (
                    <p style={{ color: "#d32f2f", fontSize: "12px" }}>
                      You can add up to 500 characters only*
                    </p>
                  ) : (
                    ""
                  )} */}
                  </Grid>
                </Grid>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: update ? "25%" : "25%",
                    }}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      style={{
                        backgroundColor: "#406882",
                        color: "white",
                        textTransform: "capitalize",
                      }}
                      onClick={() => {
                        setValue(2);
                        //dispatch(IsOpenSummary(false));
                      }}
                    >
                      Previous
                    </Button>
                    {/* <Button
                      variant="contained"
                      type="submit"
                      size="small"
                      style={{
                        backgroundColor: "#406882",
                        color: "white",
                        textTransform: "capitalize",
                      }}
                      //onClick={() => dispatch(setActionType("edit"))}
                    >
                      {loading ? "Updating" : "Update"}
                    </Button> */}

                    <Button
                      variant="contained"
                      type="submit"
                      size="small"
                      style={{
                        backgroundColor: "#406882",
                        color: "white",
                        textTransform: "capitalize",
                      }}
                      onClick={() => setFinish(true)}
                    >
                      Next
                    </Button>
                  </Box>

                  <Box sx={{ float: "right" }}>
                    {finish === true &&
                      (buttonLoadingOne === true ? (
                        <Button
                          variant="contained"
                          //type="submit"
                          size="small"
                          disabled
                          style={{
                            backgroundColor: "#ddd",
                            color: "#406882",
                            textTransform: "capitalize",
                          }}
                        >
                          Uploading...
                        </Button>
                      ) : (
                        <>
                          <Button
                            variant="contained"
                            //type="submit"
                            size="small"
                            style={{
                              backgroundColor: "#406882",
                              color: "white",
                              textTransform: "capitalize",
                            }}
                            onClick={HandleUpload}
                          >
                            Upload
                          </Button>{" "}
                        </>
                      ))}
                  </Box>
                </Box>
                {/* <Box sx={{ mt: 2 }}>
                  {finish ? (
                    <div class="alert alert-light" role="alert">
                      Resume has been completed ! Click on
                      {buttonLoadingOne === true ? (
                        <Button
                          style={{ textTransform: "capitalize" }}
                          disabled
                        >
                          Downloading...
                        </Button>
                      ) : (
                        <Button
                          onClick={() => {
                            contextObject.updateFinishOne(true);
                            setButtonLoadingOne(true);
                          }}
                          style={{
                            textTransform: "capitalize",
                            textDecoration: "underline",
                          }}
                        >
                          Download
                        </Button>
                      )}
                    </div>
                  ) : (
                    ''
                  )}
                </Box> */}
              </form>
            )}
          </Formik>
        </Box>
      </Box>
      {open && (
        <Box
          sx={{
            width: "500px",
            height: "410px",
            backgroundColor: "#f9f9f9",
            border: "1px solid #ccc",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            p: 2,
            position: "absolute",
            top: "0",
            right: "0",
            zIndex: 1000,
            left: "102%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {suggestionsLoading ? (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              mt={2}
              p={5}
            >
              <IconButton
                aria-label="close"
                onClick={handleRolesClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <AiOutlineCloseCircle />
              </IconButton>
              <Alert
                severity="info"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Box p={3}>
                  <AlertTitle>⏳Summarization in Progress</AlertTitle>
                  Fetching summary from AI. Please wait...
                </Box>
                <LinearProgress style={{ width: "100%" }} />
              </Alert>
            </Box>
          ) : (
            <>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  sx={{
                    mb: 2,
                    fontWeight: "bold",
                    fontSize: "15px",
                    fontFamily: "'Times New Roman', serif !important",
                  }}
                >
                  Showing {projectSuggestions?.length} results for{" "}
                  <span style={{ textTransform: "capitalize" }}>
                    {selectedProject?.pro_role}
                  </span>
                </Typography>
                <IconButton
                  aria-label="close"
                  onClick={handleRolesClose}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <AiOutlineCloseCircle />
                </IconButton>
              </Box>

              <Box
                sx={{
                  flexGrow: 1,
                  overflowY: "auto",
                }}
              >
                {paginatedData?.length > 0 ? (
                  <List
                    sx={{
                      fontSize: "12px",
                      //textAlign: "justify",
                    }}
                  >
                    {paginatedData.map((data, index) => (
                      <ListItemText
                        style={{
                          cursor: "pointer",
                          bgcolor: "#eff2f9",
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Tooltip
                            title={isCopied(index) ? "Copied" : "Copy"}
                            open={hoveredIndex === index}
                            arrow
                          >
                            <IconButton
                              size="large"
                              sx={{
                                color: isCopied(index) ? "green" : "inherit",
                                backgroundColor: isCopied(index)
                                  ? "#e0ffe0"
                                  : "aliceblue",
                                borderRadius: "50%",
                                padding: "5px",
                                "&:hover": {
                                  backgroundColor: "#d0d0d0",
                                },
                              }}
                              onMouseEnter={() => handleMouseEnter(index)}
                              onMouseLeave={handleMouseLeave}
                              onClick={() =>
                                handleSuggestionsClick(index, data)
                              }
                            //disabled={copiedIndex?.includes(index)}
                            >
                              {isCopied(index) ? (
                                <CheckIcon
                                  sx={{
                                    fontSize: "12px",
                                    color: "green",
                                  }}
                                />
                              ) : (
                                <ArrowBackIcon
                                  sx={{
                                    fontSize: "12px",
                                  }}
                                />
                              )}
                            </IconButton>
                          </Tooltip>

                          {/* Text Content */}
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontFamily: "'Times New Roman' !important",
                            }}
                          >
                            {parse(data)}
                          </Typography>
                        </Box>
                      </ListItemText>
                    ))}
                  </List>
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    <BsArrowLeftCircle size={20} color="lightgrey" />
                    &nbsp;Resume Projects Suggestions
                  </Typography>
                )}
              </Box>
              {/* Pagination Section */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 2,
                }}
              >
                <Pagination
                  count={Math.ceil(projectSuggestions?.length / ITEMS_PER_PAGE)}
                  page={currentPage}
                  onChange={handleChangePage}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                />
              </Box>
            </>
          )}
        </Box>
      )}
      {contextObject.finishOne == true && (
        <Dialog open={buttonLoadingOne} maxWidth="xs" fullWidth>
          <DialogContent
            style={{
              textAlign: "center",
              padding: "30px",
              background: "#f9f9f9",
              borderRadius: "10px",
            }}
          >
            <img
              src={HourTimer}
              alt="Loading..."
              style={{ width: "100px", height: "100px", marginBottom: "15px" }}
            />
            <Typography
              variant="h6"
              style={{ fontWeight: "bold", color: "#333" }}
            >
              It takes some time, please wait...
            </Typography>
          </DialogContent>
        </Dialog>
      )}
      <Dialog
        open={openJd}
        onClose={closeDialog}
        fullWidth
        sx={{ "& .MuiDialog-paper": { width: "750px", maxWidth: "90%" } }}
      >
        <DialogContent>
          <Box
            sx={{
              marginBottom: "15px",
              padding: 2,
              border: "1px solid #e6e1e1",
              borderRadius: "10px",
              borderTop: "3px solid #406682",
              boxShadow: "0 0 2px grey",
              backgroundColor: "white",
              //...paperstyles
            }}
          >
            <Typography variant="h6">
              <span
                style={{
                  background:
                    "linear-gradient(-90deg, #89bcdf 10%, #406882 90%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: "bold",
                }}
              >
                Job Title:
              </span>
              {` ${selectedJob?.jobtitle}`}
            </Typography>
          </Box>

          <Box
            sx={{
              padding: 2,
              //border: "1px solid #e6e1e1",
              borderRadius: "10px",
              // borderTop: "3px solid #406682",
              // boxShadow: "0 0 2px grey",
              backgroundColor: "white",
              //...paperstyles
            }}
          >
            <Typography
              variant="h6"
              sx={{
                background: "linear-gradient(-90deg, #89bcdf 10%, #406882 90%)",
                backgroundClip: "text",
                textFillColor: "transparent",
                fontWeight: "bold",
              }}
            >
              Job Description
            </Typography>
            <Typography paragraph>
              {selectedJob?.job_description !== null &&
                selectedJob?.job_description !== undefined &&
                selectedJob?.job_description
                ? !selectedJob?.job_description.includes("ahref") &&
                  !selectedJob?.job_description.includes("divclass") &&
                  !selectedJob?.job_description.includes("aclass") &&
                  !selectedJob?.job_description.includes("pclass") &&
                  !selectedJob?.job_description.includes("liclass")
                  ? parse(selectedJob?.job_description)
                  : selectedJob?.job_description.replace(/<[^>]+>/g, "")
                : ""}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
